<link href="https://fonts.googleapis.com/css2?family=Rubik:wght@700&display=swap" rel="stylesheet" />
<div class="error-wrapper" style="background-image: url('/assets/img/404.svg')">
  <!--  <img src="/assets/img/404.svg">-->
  <div class="text"> Oooops, Error. Page not found. </div>

  <a href="/">Go back</a>
</div>
